export const getLocalRecentPlaces = async () => {
  return await JSON.parse(localStorage.getItem('recentPlaces'))
}
